export default "__VITE_ASSET__CJtSnN9H__"